import { render, staticRenderFns } from "./FurnitureTile.vue?vue&type=template&id=a2211594&scoped=true"
import script from "./FurnitureTile.vue?vue&type=script&lang=js"
export * from "./FurnitureTile.vue?vue&type=script&lang=js"
import style0 from "./FurnitureTile.vue?vue&type=style&index=0&id=a2211594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2211594",
  null
  
)

export default component.exports